import { action } from 'mobx';
import Collection from 'core/model/Collection';
import api from 'core/util/api';

import CommentModel from './CommentModel';

class CommentCollection extends Collection {
  get model() {
    return CommentModel;
  }

  get defaultSortState() {
    return {
      field: 'cdate',
      direction: 'desc'
    };
  }

  get url() {
    return '/api/ui/comments';
  }

  getAckCommentForEntityById = (entityId, entityType = 'alertAck') =>
    this.models.find((model) => model.get('entityId') === entityId && model.get('entityType') === entityType);

  getAlertComments = (alertModel) =>
    this.models.filter(
      (model) => model.get('entityId') === alertModel.id || model.get('entityId') === alertModel.autoAckId
    );

  getCommentsForEntityById = (entityId) => this.models.filter((model) => model.get('entityId') === entityId);

  // Refreshes one entity's comments in place, rather than refetching every comment for the company
  fetchForEntity({ entityType, entityId }) {
    return api
      .get(this.url, { query: { entity_type: entityType, entity_id: entityId } })
      .then(action((comments) => this.replaceEntityComments({ entityType, entityId }, comments)));
  }

  @action
  replaceEntityComments({ entityType, entityId }, comments) {
    this.remove(
      this.getCommentsForEntityById(entityId)
        .filter((model) => model.get('entityType') === entityType)
        .map((model) => model.id)
    );
    return this.add(comments);
  }
}

export default CommentCollection;
